import { getApplication } from '../app';
import { asyncRaf } from './browser/browser';
import { getBody } from './browser/dom';
import { startProgress, stopProgress } from './progress';

const modals = [];
const modalIndexStep = 500;
const modalBaseIndex = 2000;
let isFetchingModal = false;

function registerModal(modalController) {
    modals.push(modalController);
}

function unregisterModal(modalController) {
    modals.splice(modals.indexOf(modalController), 1);
}

function hasOpenModals() {
    return modals.some((modal) => modal.isOpen);
}

function getAllOpenModals() {
    return modals.filter((modal) => modal.isOpen);
}

function getNextModalZIndex() {
    // TODO might need to track in-use indexes
    return modalBaseIndex + getAllOpenModals().length * modalIndexStep;
}

function getModalById(id) {
    return modals.find((modal) => modal.modalId === id);
}

async function getModalByUrl(url) {
    // find controller by openedByUrl
    let modalController = modals.find((modal) => modal.openedByUrl === url);
    if (modalController) {
        return modalController;
    }

    if (isFetchingModal) {
        return undefined;
    }

    isFetchingModal = true;

    let content = null;

    try {
        startProgress();
        const response = await fetch(url);
        content = await response.text();
        stopProgress();
    } catch (error) {
        console.error(error);
        stopProgress();
        return undefined;
    } finally {
        // eslint-disable-next-line require-atomic-updates
        isFetchingModal = false;
    }

    modalController = await openModalFromHtml(content);

    modalController._openedByUrl = url;

    return modalController;
}

function closeAllModals() {
    modals.forEach((modal) => modal.close());
}

function openModalById(id) {
    const modalController = getModalById(id);
    modalController?.open();

    return modalController;
}

async function openModalByUrl(url) {
    const modalController = await getModalByUrl(url);
    modalController?.open();

    return modalController;
}

async function openModalFromHtml(html) {
    const dom = new DOMParser().parseFromString(html, 'text/html');
    const modal = dom.querySelector('.dom-modal');

    getBody().appendChild(modal);
    await asyncRaf();

    return getApplication().getControllerForElementAndIdentifier(modal, 'dom-modal');
}

export {
    // Base
    registerModal,
    unregisterModal,
    // Helpers
    hasOpenModals,
    getAllOpenModals,
    getModalById,
    getModalByUrl,
    getNextModalZIndex,
    // Actions
    closeAllModals,
    openModalById,
    openModalByUrl,
    openModalFromHtml,
};
